import {
  AccountTree,
  Article,
  Error,
  Folder,
  LabelImportant,
} from '@mui/icons-material';
import {
  Alert,
  CircularProgress,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { useWorkspace } from 'api/providers/workspaceProvider';
import CardButton from 'components/cardButton';
import PinnedEntities from 'components/pinnedEntities';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Desktop } from './desktop';

export default function Home() {
  const workspace = useWorkspace();
  const navigate = useNavigate();

  // Loading state
  if (workspace.isLoading || !workspace.data) {
    return (
      <Stack gap={3}>
        <Skeleton variant="text" width={200} height={32} />
        <Skeleton variant="text" width={100} height={48} />
        <Stack
          mt={3}
          gap={2}
          alignItems="flex-start"
          direction="row"
          flexWrap="wrap"
        >
          <Skeleton variant="rectangular" width={200} height={150} />
          <Skeleton variant="rectangular" width={200} height={150} />
          <Skeleton variant="rectangular" width={200} height={150} />
          <Skeleton variant="rectangular" width={200} height={150} />
        </Stack>
      </Stack>
    );
  }

  // Error state
  if (workspace.error) {
    return (
      <Stack gap={2}>
        <Alert
          severity="error"
          icon={<Error />}
          action={<CircularProgress size={20} />}
        >
          Failed to load workspace data. Please try refreshing the page.
        </Alert>
        <Typography variant="h4">Home</Typography>
      </Stack>
    );
  }

  if (false as any) return <Desktop />;

  return (
    <Stack gap={3}>
      <Stack>
        <Typography>{workspace.data?.name}</Typography>
        <Typography variant="h4">Home</Typography>
      </Stack>

      <PinnedEntities />

      <Stack>
        <Typography variant="h6" mb={2}>
          Quick Actions
        </Typography>
        <Stack gap={2} alignItems="flex-start" direction="row" flexWrap="wrap">
          <CardButton
            icon={<Folder />}
            title="Groups"
            description="Organize your content"
            onClick={() => navigate(`/workspace/${workspace.data?.id}/groups`)}
          />
          <CardButton
            icon={<LabelImportant />}
            title="Items"
            description="Manage your items"
            onClick={() => navigate(`/workspace/${workspace.data?.id}/items`)}
          />
          <CardButton
            icon={<Article />}
            title="Scratchpad"
            description="Quickly take notes"
            onClick={() =>
              navigate(`/workspace/${workspace.data?.id}/scratchpad`)
            }
          />
          <CardButton
            icon={<AccountTree />}
            title="Projects"
            description="Manage your projects"
            onClick={() =>
              navigate(`/workspace/${workspace.data?.id}/projects`)
            }
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
